export const primeHoldingConstants = {

    PRIME_HOLDING_SAGA: "PRIME_HOLDING_SAGA",
    PRIME_HOLDING_REQUEST: "PRIME_HOLDING_REQUEST",
    PRIME_HOLDING_RESPONSE: "PRIME_HOLDING_RESPONSE",
    PRIME_HOLDING_API: "v1/masters/portfolio-allocation",
};
